export enum ApplicantStage {
  PROSPECT = 'PROSPECT',
  HIRED = 'HIRED',
  TERMINATED = 'TERMINATED',
  NOT_INTERESTED = 'NOT_INTERESTED',
  DISQUALIFIED = 'DISQUALIFIED',
}

export enum HiringStage {
  LEAD = 'LEAD',
  APPLICATION = 'APPLICATION',
  QUALIFICATION = 'QUALIFICATION',
  ONBOARDING = 'ONBOARDING',
}

export enum NotInterestedReason {
  ACCEPTED_ANOTHER_JOB = 'ACCEPTED_ANOTHER_JOB',
  BENEFITS = 'BENEFITS',
  CAMERAS = 'CAMERAS',
  CAREER_CHANGE = 'CAREER_CHANGE',
  DECLINED_JOB_OFFER = 'DECLINED_JOB_OFFER',
  DISLIKES_TEAM_DRIVING = 'DISLIKES_TEAM_DRIVING',
  DISTANCE = 'DISTANCE',
  EQUIPMENT_PREFERENCES = 'EQUIPMENT_PREFERENCES',
  FAMILY_ISSUES = 'FAMILY_ISSUES',
  FUTURE_PROSPECT = 'FUTURE_PROSPECT',
  HAPPY_WITH_CURRENT_JOB = 'HAPPY_WITH_CURRENT_JOB',
  HOME_TIME_PREFERENCES = 'HOME_TIME_PREFERENCES',
  INTEREST_IN_LOCAL_ROLES = 'INTEREST_IN_LOCAL_ROLES',
  LICENSE_REQUIREMENTS = 'LICENSE_REQUIREMENTS',
  LOST_CONTACT = 'LOST_CONTACT',
  MILEAGE_CONCERNS = 'MILEAGE_CONCERNS',
  NO_CONTACT_REQUESTED = 'NO_CONTACT_REQUESTED',
  NOT_CONTACTED = 'NOT_CONTACTED',
  OTHER = 'OTHER',
  PAY_CONCERNS = 'PAY_CONCERNS',
  PET_POLICY = 'PET_POLICY',
  POSITION_NOT_AVAILABLE = 'POSITION_NOT_AVAILABLE',
  PREFERRED_POSITION_UNAVAILABLE = 'PREFERRED_POSITION_UNAVAILABLE',
  RETIRED = 'RETIRED',
  TIMING = 'TIMING',
  TRAINING_COST = 'TRAINING_COST',
}

export enum DisqualifiedReason {
  ACCIDENT = 'ACCIDENT',
  BELOW_AGE_REQUIREMENT = 'BELOW_AGE_REQUIREMENT',
  COMPANY_POLICY = 'COMPANY_POLICY',
  CRIMINAL_RECORD = 'CRIMINAL_RECORD',
  CULTURE_FIT = 'CULTURE_FIT',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  DRIVING_SCHOOL = 'DRIVING_SCHOOL',
  DRUG_SCREEN_FAILURE = 'DRUG_SCREEN_FAILURE',
  DUPLICATE_PROFILE = 'DUPLICATE_PROFILE',
  EMPLOYMENT_HISTORY = 'EMPLOYMENT_HISTORY',
  ENDORSEMENTS = 'ENDORSEMENTS',
  ENGLISH_PROFICIENCY = 'ENGLISH_PROFICIENCY',
  EQUIPMENT_PREFERENCES = 'EQUIPMENT_PREFERENCES',
  HOME_TIME_PREFERENCES = 'HOME_TIME_PREFERENCES',
  INSURANCE = 'INSURANCE',
  INTERVIEW = 'INTERVIEW',
  LACK_OF_EXPERIENCE = 'LACK_OF_EXPERIENCE',
  LEASE_NOT_APPROVED = 'LEASE_NOT_APPROVED',
  LOCATION_MISMATCH = 'LOCATION_MISMATCH',
  MEDICAL_REASONS = 'MEDICAL_REASONS',
  MOTOR_VEHICLE_RECORD = 'MOTOR_VEHICLE_RECORD',
  NO_FAST = 'NO_FAST',
  NO_SHOW = 'NO_SHOW',
  OTHER = 'OTHER',
  OUT_OF_HIRING_AREA = 'OUT_OF_HIRING_AREA',
  POOR_REFERENCES = 'POOR_REFERENCES',
  ROAD_TEST = 'ROAD_TEST',
  SAP = 'SAP',
}

export const TerminatedReason = {
  ATTENDANCE_ISSUES: 'ATTENDANCE_ISSUES',
  CAREER_CHANGE: 'CAREER_CHANGE',
  DECEASED: 'DECEASED',
  DISPATCH: 'DISPATCH',
  END_OF_CONTRACT: 'END_OF_CONTRACT',
  EQUIPMENT: 'EQUIPMENT',
  FAILED_DRUG_SCREEN: 'FAILED_DRUG_SCREEN',
  HOME_TIME: 'HOME_TIME',
  INSUBORDINATION: 'INSUBORDINATION',
  INSUFFICIENT_WORK: 'INSUFFICIENT_WORK',
  JOB_ABANDONMENT: 'JOB_ABANDONMENT',
  JOINED_COMPETITOR: 'JOINED_COMPETITOR',
  LAYOFF_REDUNDANCY: 'LAYOFF_REDUNDANCY',
  MEDICAL: 'MEDICAL',
  OTHER: 'OTHER',
  PAY: 'PAY',
  PERFORMANCE_ISSUES: 'PERFORMANCE_ISSUES',
  RETIRED: 'RETIRED',
  SAFETY_VIOLATION: 'SAFETY_VIOLATION',
  STARTED_OWN_BUSINESS: 'STARTED_OWN_BUSINESS',
  TRANSFER: 'TRANSFER',
  VIOLATION_OF_COMPANY_POLICY: 'VIOLATION_OF_COMPANY_POLICY',
  VOLUNTARY_TERMINATION: 'VOLUNTARY_TERMINATION',
}
